import React, { useState, useEffect, useContext } from "react";
import { Link, useParams } from "react-router-dom";
import auth from "../../helper/auth-helper";
import { addArticle } from "../../helper/api-archives";
import { GlobalContext } from "../../context/GlobalContext";
import { decode, encode } from "html-entities";

export default function AddArticle(props) {
  const { flash, setFlash, settings } = useContext(GlobalContext);
  const { year, vol, issue } = useParams();
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isCreated, setIsCreated] = useState(false);

  const [article, setArticle] = useState({
    txnid: "",
    ptype: "paid",
    publishdate: new Date().toISOString().slice(0, 10),
    authorname: "",
    pagenumber: "",
    subject: "",
    country: "",
    refnumber: "",
    email: "",
    mobile: "",
    title: "",
    description: "",
    keywords: "",
    abstract: "",
  });

  const [pdffile, setPdfFile] = useState();

  const jwt = auth.isAuthenticated();

  const numPresent=(a)=>{
    for(let i=0;i<a.length;i++){
      if(a.charCodeAt(i)>=65 && a.charCodeAt(i)<=90){
        console.log("working");
        return false;
      }
    }
    return true;
  }

  const handleChange = (name) => (event) => {
    if(name==="txnid"){
      let a=event.target.value;
      if(numPresent(a)){
        setArticle({ ...article, [name]: event.target.value,ptype:"free" });
      }
      else{
        setArticle({ ...article, [name]: event.target.value,ptype:"paid" });
      }
      return;
    }
    setArticle({ ...article, [name]: event.target.value });
    console.log(article);
  };

  const handleChangeContent = (name) => (event) => {
    setArticle({ ...article, [name]: event.target.innerHTML });
  };

  const handleChangeFile = (event) => {
    const file = event.target.files[0];
    if (file) {
      const maxSize = 5 * 1024 * 1024; // 5 MB
      if (file.size < maxSize) {
        setPdfFile(file);
      } else {
        alert("File size exceeds the limit of 5 MB.");
        setPdfFile(null);
      }
    }
  };
  const handleSubmit = () => {
    debugger
    setIsSubmitted(true);
    let data = article;
    if (
      !data.txnid ||
      !data.ptype ||
      !data.publishdate ||
      !data.authorname ||
      !data.pagenumber ||
      !data.refnumber ||
      !data.email ||
      !data.country ||
      !pdffile ||
      !document.getElementById("rich-title").textContent ||
      !document.getElementById("rich-abstract").textContent
    ) {
      return;
    }

    let articleData = article;
    articleData = {
      ...articleData,
      title: encode(document.getElementById("rich-title").innerHTML),
      abstract: encode(document.getElementById("rich-abstract").innerHTML),
      year: year,
      volume: vol,
      issue: issue,
      file: `${articleData.refnumber}.pdf`,
      status: "enabled",
      modifiedby: jwt.user,
      modification: new Date(),
      createdby: jwt.user,
      creation: new Date(),
    };

    addArticle(articleData, pdffile, { token: jwt.token }).then((data) => {
      if (data && data.error) {
        if (data.error == "duplicate_reference_number")
          setFlash({ error: true, msg: "Duplicate reference number" });
        else if (data.error == "duplicate_title")
          setFlash({ error: true, msg: "Duplicate title" });
        else if (data.error == "duplicate_txnid")
          setFlash({ error: true, msg: "Transaction ID Already Used" });
        else if (data.error == "invalid_txnid")
          setFlash({ error: true, msg: "Invalid transaction id" });
        else if (data.error == "invalid_pagenumber")
          setFlash({ error: true, msg: "Invalid page number" });
        else setFlash({ error: true, msg: "Something went wrong" });
      } else {
        setFlash({
          normal: true,
          msg: (
            <div className="flex flex-col">
              <div>
                <b>Dear Author,</b>
              </div>
              <br />
              <div>
                <div>
                  <b>
                    1. Your article has been published, kindly download pdf,
                    certificate and coverpage from the given link.
                  </b>
                </div>
                <div className="flex gap-1 ">
                  <div>Link:&nbsp;</div>
                  <Link
                    to={`/pdf?refno=${article.refnumber}`}
                  >{`https://${settings.domain}/pdf?refno=${article.refnumber}`}</Link>
                </div>
              </div>
              <br />
              <div>
                <div>
                  <b>2. Also add your article in Google Scholar for citation</b>
                </div>
                <div className="flex gap-1">
                  <div>Link:&nbsp;</div>
                  <Link to="https://scholar.google.com">
                    https://scholar.google.com
                  </Link>
                </div>
              </div>
              <br />
              <div>
                <div>
                  3. Watch video on how to create Google Scholar profile
                </div>
                <div className="flex gap-1">
                  <div>Link:&nbsp;</div>
                  <Link to="https://www.youtube.com/watch?v=6JZ6TQoWc58">
                    https://www.youtube.com/watch?v=6JZ6TQoWc58
                  </Link>
                </div>
              </div>
              <br />
              <div>
                <div>
                  4. Watch video on how to upload published article in Google
                  Scholar
                </div>
                <div className="flex gap-1">
                  <div>Link:&nbsp;</div>
                  <Link to="https://www.youtube.com/watch?v=VMjncGlNn0w">
                    https://www.youtube.com/watch?v=VMjncGlNn0w
                  </Link>
                </div>
              </div>
            </div>
          ),
        });
        setIsCreated(true);
      }
    });
  };

  return (
    <div>
      <div className="flex gap-4">
        <Link
          to={`/admin/archives/${year}/${vol}/${issue}`}
          className="w-16 p-2 mb-4 text-center text-gray-500 bg-gray-200 rounded"
        >
          <i className="fa fa-arrow-left" aria-hidden="true" />
        </Link>
        {!isCreated && (
          <button
            onClick={handleSubmit}
            className="w-24 p-2 mb-4 text-gray-100 rounded bg-sky-600"
          >
            Submit
          </button>
        )}
      </div>
      <div className="grid grid-cols-5 gap-4">
        <div>
          <div>TRANSACTION ID *</div>
          <input
            onChange={handleChange("txnid")} value={article.txnid}
            className={`w-full border-2 border-gray-300 rounded p-2 focus:outline-emerald-600 ${isSubmitted && !article.txnid ? "border-b-red-500" : ""}`}
            type="text"
          />
        </div>
        <div>
          <div>PAYMENT TYPE</div>
          <select
            onChange={handleChange("ptype")}
            value={article.ptype}
            className={`w-full border-2 border-gray-300 rounded p-2 focus:outline-emerald-600 ${isSubmitted && !article.ptype ? "border-b-red-500" : ""}`}
          >
            <option value="paid">Paid</option>
            <option value="free">Free</option>
          </select>
        </div>
        <div>
          <div>EXTRACT ON</div>
          <input
            onChange={handleChange("publishdate")}
            value={article.publishdate}
            className={`w-full border-2 border-gray-300 rounded p-2 focus:outline-emerald-600 ${isSubmitted && !article.publishdate ? "border-b-red-500" : ""
              }`}
            type="date"
          />
        </div>
        <div className="col-span-2 row-span-2">
          <div>AUTHOR NAME *</div>
          <textarea
            onChange={handleChange("authorname")}
            value={article.authorname}
            className={`h-32 resize-none w-full p-2 focus:outline-emerald-600 border-2 border-gray-300 rounded ${isSubmitted && !article.authorname ? "border-b-red-500" : ""
              }`}
          />
        </div>
        <div>
          <div>PAGE NUMBER *</div>
          <input
            onChange={handleChange("pagenumber")}
            value={article.pagenumber}
            className={`w-full border-2 border-gray-300 rounded p-2 focus:outline-emerald-600 ${isSubmitted && !article.pagenumber ? "border-b-red-500" : ""
              }`}
            type="text"
          />
        </div>
        <div>
          <div>SUBJECT</div>
          <input
            onChange={handleChange("subject")}
            value={article.subject}
            className={`w-full border-2 border-gray-300 rounded p-2 focus:outline-emerald-600`}
            type="text"
          />
        </div>
        <div>
          <div>COUNTRY *</div>
          {/* <input
            onChange={handleChange("country")}
            value={article.country}
            className={`w-full border-2 border-gray-300 rounded p-2 focus:outline-emerald-600 ${isSubmitted && !article.country ? "border-b-red-500" : ""
              }`}
            type="text"
          /> */}
          <select
                onChange={handleChange("country")}
                value={article.country}
                className={`w-full border-2 border-gray-300 p-2 focus:outline-emerald-600 `}
              >
                <option value="">Select Country</option>
                <option value="Afghanistan">Afghanistan</option>
                <option value="Albania">Albania</option>
                <option value="Algeria">Algeria</option>
                <option value="American Samoa">American Samoa</option>
                <option value="Andorra">Andorra</option>
                <option value="Angola">Angola</option>
                <option value="Anguilla">Anguilla</option>
                <option value="Antarctica">Antarctica</option>
                <option value="Antigua and Barbuda">Antigua and Barbuda</option>
                <option value="Argentina">Argentina</option>
                <option value="Armenia">Armenia</option>
                <option value="Aruba">Aruba</option>
                <option value="Australia">Australia</option>
                <option value="Austria">Austria</option>
                <option value="Azerbaijan">Azerbaijan</option>
                <option value="Bahamas">Bahamas</option>
                <option value="Bahrain">Bahrain</option>
                <option value="Bangladesh">Bangladesh</option>
                <option value="Barbados">Barbados</option>
                <option value="Belarus">Belarus</option>
                <option value="Belgium">Belgium</option>
                <option value="Belize">Belize</option>
                <option value="Benin">Benin</option>
                <option value="Bermuda">Bermuda</option>
                <option value="Bhutan">Bhutan</option>
                <option value="Bolivia">Bolivia</option>
                <option value="Bosnia and Herzegovina">
                  Bosnia and Herzegovina
                </option>
                <option value="Botswana">Botswana</option>
                <option value="Bouvet Island">Bouvet Island</option>
                <option value="Brazil">Brazil</option>
                <option value="British Indian Ocean Territory">
                  British Indian Ocean Territory
                </option>
                <option value="Brunei Darussalam">Brunei Darussalam</option>
                <option value="Bulgaria">Bulgaria</option>
                <option value="Burkina Faso">Burkina Faso</option>
                <option value="Burundi">Burundi</option>
                <option value="Cambodia">Cambodia</option>
                <option value="Cameroon">Cameroon</option>
                <option value="Canada">Canada</option>
                <option value="Cape Verde">Cape Verde</option>
                <option value="Cayman Islands">Cayman Islands</option>
                <option value="Central African Republic">
                  Central African Republic
                </option>
                <option value="Chad">Chad</option>
                <option value="Chile">Chile</option>
                <option value="China">China</option>
                <option value="Christmas Island">Christmas Island</option>
                <option value="Cocos (Keeling) Islands">
                  Cocos (Keeling) Islands
                </option>
                <option value="Colombia">Colombia</option>
                <option value="Comoros">Comoros</option>
                <option value="Congo">Congo</option>
                <option value="Congo, the Democratic Republic of the">
                  Congo, the Democratic Republic of the
                </option>
                <option value="Cook Islands">Cook Islands</option>
                <option value="Costa Rica">Costa Rica</option>
                <option value="Cote D'Ivoire">Cote D'Ivoire</option>
                <option value="Croatia">Croatia</option>
                <option value="Cuba">Cuba</option>
                <option value="Cyprus">Cyprus</option>
                <option value="Czech Republic">Czech Republic</option>
                <option value="Denmark">Denmark</option>
                <option value="Djibouti">Djibouti</option>
                <option value="Dominica">Dominica</option>
                <option value="Dominican Republic">Dominican Republic</option>
                <option value="Ecuador">Ecuador</option>
                <option value="Egypt">Egypt</option>
                <option value="El Salvador">El Salvador</option>
                <option value="Equatorial Guinea">Equatorial Guinea</option>
                <option value="Eritrea">Eritrea</option>
                <option value="Estonia">Estonia</option>
                <option value="Ethiopia">Ethiopia</option>
                <option value="Falkland Islands (Malvinas)">
                  Falkland Islands (Malvinas)
                </option>
                <option value="Faroe Islands">Faroe Islands</option>
                <option value="Fiji">Fiji</option>
                <option value="Finland">Finland</option>
                <option value="France">France</option>
                <option value="French Guiana">French Guiana</option>
                <option value="French Polynesia">French Polynesia</option>
                <option value="French Southern Territories">
                  French Southern Territories
                </option>
                <option value="Gabon">Gabon</option>
                <option value="Gambia">Gambia</option>
                <option value="Georgia">Georgia</option>
                <option value="Germany">Germany</option>
                <option value="Ghana">Ghana</option>
                <option value="Gibraltar">Gibraltar</option>
                <option value="Greece">Greece</option>
                <option value="Greenland">Greenland</option>
                <option value="Grenada">Grenada</option>
                <option value="Guadeloupe">Guadeloupe</option>
                <option value="Guam">Guam</option>
                <option value="Guatemala">Guatemala</option>
                <option value="Guinea">Guinea</option>
                <option value="Guinea-Bissau">Guinea-Bissau</option>
                <option value="Guyana">Guyana</option>
                <option value="Haiti">Haiti</option>
                <option value="Heard Island and Mcdonald Islands">
                  Heard Island and Mcdonald Islands
                </option>
                <option value="Holy See (Vatican City State)">
                  Holy See (Vatican City State)
                </option>
                <option value="Honduras">Honduras</option>
                <option value="Hong Kong">Hong Kong</option>
                <option value="Hungary">Hungary</option>
                <option value="Iceland">Iceland</option>
                <option value="India">India</option>
                <option value="Indonesia">Indonesia</option>
                <option value="Iran, Islamic Republic of">
                  Iran, Islamic Republic of
                </option>
                <option value="Iraq">Iraq</option>
                <option value="Ireland">Ireland</option>
                <option value="Israel">Israel</option>
                <option value="Italy">Italy</option>
                <option value="Jamaica">Jamaica</option>
                <option value="Japan">Japan</option>
                <option value="Jordan">Jordan</option>
                <option value="Kazakhstan">Kazakhstan</option>
                <option value="Kenya">Kenya</option>
                <option value="Kiribati">Kiribati</option>
                <option value="Korea, Democratic People's Republic of">
                  Korea, Democratic People's Republic of
                </option>
                <option value="Korea, Republic of">Korea, Republic of</option>
                <option value="Kuwait">Kuwait</option>
                <option value="Kyrgyzstan">Kyrgyzstan</option>
                <option value="Lao People's Democratic Republic">
                  Lao People's Democratic Republic
                </option>
                <option value="Latvia">Latvia</option>
                <option value="Lebanon">Lebanon</option>
                <option value="Lesotho">Lesotho</option>
                <option value="Liberia">Liberia</option>
                <option value="Libyan Arab Jamahiriya">
                  Libyan Arab Jamahiriya
                </option>
                <option value="Liechtenstein">Liechtenstein</option>
                <option value="Lithuania">Lithuania</option>
                <option value="Luxembourg">Luxembourg</option>
                <option value="Macao">Macao</option>
                <option value="Macedonia, the Former Yugoslav Republic of">
                  Macedonia, the Former Yugoslav Republic of
                </option>
                <option value="Madagascar">Madagascar</option>
                <option value="Malawi">Malawi</option>
                <option value="Malaysia">Malaysia</option>
                <option value="Maldives">Maldives</option>
                <option value="Mali">Mali</option>
                <option value="Malta">Malta</option>
                <option value="Marshall Islands">Marshall Islands</option>
                <option value="Martinique">Martinique</option>
                <option value="Mauritania">Mauritania</option>
                <option value="Mauritius">Mauritius</option>
                <option value="Mayotte">Mayotte</option>
                <option value="Mexico">Mexico</option>
                <option value="Micronesia, Federated States of">
                  Micronesia, Federated States of
                </option>
                <option value="Moldova, Republic of">
                  Moldova, Republic of
                </option>
                <option value="Monaco">Monaco</option>
                <option value="Mongolia">Mongolia</option>
                <option value="Montserrat">Montserrat</option>
                <option value="Morocco">Morocco</option>
                <option value="Mozambique">Mozambique</option>
                <option value="Myanmar">Myanmar</option>
                <option value="Namibia">Namibia</option>
                <option value="Nauru">Nauru</option>
                <option value="Nepal">Nepal</option>
                <option value="Netherlands">Netherlands</option>
                <option value="Netherlands Antilles">
                  Netherlands Antilles
                </option>
                <option value="New Caledonia">New Caledonia</option>
                <option value="New Zealand">New Zealand</option>
                <option value="Nicaragua">Nicaragua</option>
                <option value="Niger">Niger</option>
                <option value="Nigeria">Nigeria</option>
                <option value="Niue">Niue</option>
                <option value="Norfolk Island">Norfolk Island</option>
                <option value="Northern Mariana Islands">
                  Northern Mariana Islands
                </option>
                <option value="Norway">Norway</option>
                <option value="Oceania">Oceania</option>
                <option value="Oman">Oman</option>
                <option value="Pakistan">Pakistan</option>
                <option value="Palau">Palau</option>
                <option value="Palestinian Territory, Occupied">
                  Palestinian Territory, Occupied
                </option>
                <option value="Panama">Panama</option>
                <option value="Papua New Guinea">Papua New Guinea</option>
                <option value="Paraguay">Paraguay</option>
                <option value="Peru">Peru</option>
                <option value="Philippines">Philippines</option>
                <option value="Pitcairn">Pitcairn</option>
                <option value="Poland">Poland</option>
                <option value="Portugal">Portugal</option>
                <option value="Puerto Rico">Puerto Rico</option>
                <option value="Qatar">Qatar</option>
                <option value="Reunion">Reunion</option>
                <option value="Romania">Romania</option>
                <option value="Russia">Russia</option>
                <option value="Russian Federation">Russian Federation</option>
                <option value="Rwanda">Rwanda</option>
                <option value="Saint Helena">Saint Helena</option>
                <option value="Saint Kitts and Nevis">
                  Saint Kitts and Nevis
                </option>
                <option value="Saint Lucia">Saint Lucia</option>
                <option value="Saint Pierre and Miquelon">
                  Saint Pierre and Miquelon
                </option>
                <option value="Saint Vincent and the Grenadines">
                  Saint Vincent and the Grenadines
                </option>
                <option value="Samoa">Samoa</option>
                <option value="San Marino">San Marino</option>
                <option value="Sao Tome and Principe">
                  Sao Tome and Principe
                </option>
                <option value="Saudi Arabia">Saudi Arabia</option>
                <option value="Senegal">Senegal</option>
                <option value="Serbia and Montenegro">
                  Serbia and Montenegro
                </option>
                <option value="Seychelles">Seychelles</option>
                <option value="Sierra Leone">Sierra Leone</option>
                <option value="Singapore">Singapore</option>
                <option value="Slovakia">Slovakia</option>
                <option value="Slovenia">Slovenia</option>
                <option value="Solomon Islands">Solomon Islands</option>
                <option value="Somalia">Somalia</option>
                <option value="South Africa">South Africa</option>
                <option value="South Georgia and the South Sandwich Islands">
                  South Georgia and the South Sandwich Islands
                </option>
                <option value="Spain">Spain</option>
                <option value="Sri Lanka">Sri Lanka</option>
                <option value="Sudan">Sudan</option>
                <option value="Suriname">Suriname</option>
                <option value="Svalbard and Jan Mayen">
                  Svalbard and Jan Mayen
                </option>
                <option value="Swaziland">Swaziland</option>
                <option value="Sweden">Sweden</option>
                <option value="Switzerland">Switzerland</option>
                <option value="Syrian Arab Republic">
                  Syrian Arab Republic
                </option>
                <option value="Taiwan, Province of China">
                  Taiwan, Province of China
                </option>
                <option value="Tajikistan">Tajikistan</option>
                <option value="Tanzania, United Republic of">
                  Tanzania, United Republic of
                </option>
                <option value="Thailand">Thailand</option>
                <option value="Timor-Leste">Timor-Leste</option>
                <option value="Togo">Togo</option>
                <option value="Tokelau">Tokelau</option>
                <option value="Tonga">Tonga</option>
                <option value="Trinidad and Tobago">Trinidad and Tobago</option>
                <option value="Tunisia">Tunisia</option>
                <option value="Turkey">Turkey</option>
                <option value="Turkmenistan">Turkmenistan</option>
                <option value="Turks and Caicos Islands">
                  Turks and Caicos Islands
                </option>
                <option value="Tuvalu">Tuvalu</option>
                <option value="Uganda">Uganda</option>
                <option value="Ukraine">Ukraine</option>
                <option value="United Arab Emirates">
                  United Arab Emirates
                </option>
                <option value="United Kingdom">United Kingdom</option>
                <option value="United States">United States</option>
                <option value="United States Minor Outlying Islands">
                  United States Minor Outlying Islands
                </option>
                <option value="United States of America">
                  United States of America
                </option>
                <option value="Uruguay">Uruguay</option>
                <option value="Uzbekistan">Uzbekistan</option>
                <option value="Vanuatu">Vanuatu</option>
                <option value="Venezuela">Venezuela</option>
                <option value="Viet Nam">Viet Nam</option>
                <option value="Virgin Islands, British">
                  Virgin Islands, British
                </option>
                <option value="Virgin Islands, U.s.">
                  Virgin Islands, U.s.
                </option>
                <option value="Wallis and Futuna">Wallis and Futuna</option>
                <option value="Western Sahara">Western Sahara</option>
                <option value="Yemen">Yemen</option>
                <option value="Zambia">Zambia</option>
                <option value="Zimbabwe">Zimbabwe</option>{" "}
              </select>
        </div>

        <div>
          <div>REFERENCE NUMBER *</div>
          <input
            onChange={handleChange("refnumber")}
            value={article.refnumber}
            className={`w-full border-2 border-gray-300 rounded p-2 focus:outline-emerald-600 ${isSubmitted && article.refnumber === "" ? "border-b-red-500" : ""
              }`}
            type="text"
          />
        </div>
        <div>
          <div>EMAIL *</div>
          <input
            onChange={handleChange("email")}
            value={article.email}
            className={`w-full border-2 border-gray-300 rounded p-2 focus:outline-emerald-600 `}
            type="text"
          />
        </div>
        <div>
          <div>PHONE</div>
          <input
            onChange={handleChange("mobile")}
            value={article.mobile}
            type="text"
            className={`w-full border-2 border-gray-300 rounded p-2 focus:outline-emerald-600`}
          />
        </div>
        <div className="col-span-2 row-span-2">
          <div>TITLE *</div>
          <div
            id="rich-title"
            contentEditable={true}
            className={`h-32 overflow-scroll bg-white w-full border-2 border-gray-300 rounded p-2 focus:outline-emerald-600 ${isSubmitted && !document.getElementById("rich-title").textContent
              ? "border-b-red-500"
              : ""
              }`}
            dangerouslySetInnerHTML={{ __html: decode(article.title) }}
          ></div>
        </div>
        <div className="col-span-3">
          <div>DESCRIPTION</div>
          <input
            onChange={handleChange("description")}
            value={article.description}
            className={`w-full border-2 border-gray-300 rounded p-2 focus:outline-emerald-600`}
            type="text"
          />
        </div>
        <div className="col-span-3">
          <div>KEYWORDS</div>
          <input
            onChange={handleChange("keywords")}
            value={article.keywords}
            className={`w-full border-2 border-gray-300 rounded p-2 focus:outline-emerald-600`}
            type="text"
          />
        </div>
        <div className="col-span-2 row-span-3">
          <div>ABSTRACT *</div>
          <div
            id="rich-abstract"
            contentEditable={true}
            className={`h-32 overflow-scroll w-full bg-white border-2 border-gray-300 rounded p-2 focus:outline-emerald-600 ${isSubmitted &&
              !document.getElementById("rich-abstract").textContent
              ? "border-b-red-500"
              : ""
              }`}
            dangerouslySetInnerHTML={{ __html: decode(article.abstract) }}
          ></div>
        </div>
        <div className={`col-span-3`}>
          <div>UPLOAD *</div>
          <input
            onChange={handleChangeFile}
            type="file"
            accept="application/pdf"
            className={`w-full bg-white border-2 border-gray-300 rounded ${isSubmitted && !pdffile ? "border-b-red-500" : ""
              } p-2 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:bg-emerald-600 file:text-gray-100`}
          />
        </div>
      </div>
    </div>
  );
}
